import { Vertex3 } from '../vertex-3.class';

export const distance3 = (point1: Vertex3, point2: Vertex3): number => {
	const dx = point2.x - point1.x;
	const dy = point2.y - point1.y;
	const dz = point2.z - point1.z;

	return Math.sqrt((dx * dx) + (dy * dy) + (dz * dz));
};
